import React from 'react';


const Stiff_Intro = () => {
    return (
        <div>
            <div className='title-margins'>
                <h2>Introduction to Hamstring Strain (caused by Stiffness)</h2>
                
            </div>
            <div className='title-break'>
                <span>High Risk Sports</span>
            </div>
            <div className='high-risk-list my-3 py-1'>
                <div className="result-sport-figure">
                    <img src='/assets/imgs/results/athletes/quarterback.png' alt="" />
                    <span>Football</span>
                </div>
                <div className="result-sport-figure mb-2">
                    <img src='/assets/imgs/results/athletes/track.png' alt=""/>
                    <span>Sprinting</span>
                </div>
                <div className="result-sport-figure">
                    <img src='/assets/imgs/results/athletes/soccer.png' alt=""/>
                    <span>Soccer</span>
                </div>
            </div>
            <div className='title-break'>
                <span>Overview</span>
            </div>
            
            <div className="card">
                <img src="/assets/imgs/results/content/sprinter.jpg" alt="" height={200} className="overview-img" />
                <p>Hamstring strains are one of the most common muscle injuries in running and field sports, especially in activities that involve sprinting, sudden acceleration, or kicking. The hamstrings are a group of three muscles on the back of the thigh—the biceps femoris, semitendinosus, and semimembranosus—that cross both the hip and knee joints. They extend the hip and flex the knee, and they play a critical role in controlling the leg during high-speed movement. </p>
                <p>A hamstring strain occurs when the muscle fibers or the muscle–tendon junction are overstretched or overloaded. This usually happens when the muscle is actively contracting while being lengthened, a type of contraction called eccentric contraction. During sprinting, this occurs in the late swing phase, when the leg is moving forward and the hamstrings are working hard to slow the knee extension and prepare the foot for ground contact. At this moment, the hamstrings are near their maximum length and under high force, which makes them vulnerable to injury.</p>
                <p className="mb-0">Mild strains involve small numbers of muscle fibers and may cause soreness or tightness but allow continued activity. Moderate strains involve partial tearing of the muscle and typically cause sharp pain, weakness, and limited range of motion. Severe strains can involve large tears or even complete rupture of the muscle or tendon, often requiring surgery and long rehabilitation.
</p>

            </div>
            <div className='title-break'>
                <span>Frequency</span>
            </div>
            <div className="card">
                <p className="mb-0">Hamstring strains are especially common in sports that involve high-speed running, sprinting, rapid acceleration/deceleration, or kicking, because those movements place the hamstrings under large eccentric loads at long muscle lengths.</p>
                <table        className="default-table"
      >
  <thead>
    <tr>
      <th>Sport</th>
      <th>Typical hamstring strain incidence (injuries per 1,000 athlete-hours)</th>
      <th>Notes</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Soccer </td>
      <td>0.3–1.9 overall; ~5.0 in matches</td>
      <td>Often the most common muscle injury.</td>
    </tr>
    <tr>
      <td>Rugby (union/league)</td>
      <td>~0.5–1.0 in training; ~2–6 in matches</td>
      <td>High sprint demands plus contact/chaotic movement.</td>
    </tr>
    <tr>
      <td>Track sprinting / athletics</td>
      <td>&gt;5–10 </td>
      <td>Very high per-athlete risk.</td>
    </tr>
    <tr>
      <td>American football</td>
      <td>~0.5 in training; ~2.7 in games</td>
      <td>Skill positions typically highest.</td>
    </tr>
    <tr>
      <td>Field hockey / Australian football</td>
      <td>~0.5–1.5</td>
      <td>Continuous high-speed running.</td>
    </tr>
    <tr>
      <td>Baseball</td>
      <td>~0.2–0.6</td>
      <td>More common in base stealing and the outfield.</td>
    </tr>
  </tbody>
</table>
            </div>
            <div className='title-break'>
                <span>Muscle Stiffness and Hamstring Strains</span>
            </div>
            <div className="card">
                <p>Muscle stiffness plays a major role in hamstring strain risk because it determines how the muscle–tendon unit responds when it is stretched under load, especially during high-speed running. In sprinting, the hamstrings are rapidly lengthened while they are actively contracting (eccentric contraction), particularly during the late swing phase when the leg is preparing to strike the ground. This combination of high force and high lengthening is exactly when strains tend to occur.</p>
                <p>When a hamstring is relatively stiff, it resists lengthening and transmits force very efficiently. That can be beneficial for power and sprint performance, but it also means that when the muscle is stretched, the deformation is concentrated within the muscle fibers rather than being distributed through more compliant tissue. As a result, local tissue strain can become very high. If the strain exceeds what the muscle fibers and connective tissue can tolerate, microtears occur, which can progress to a clinically significant strain injury. This is why athletes with higher passive hamstring stiffness, especially after a previous injury, often show elevated re-injury risk.</p>
            </div>
        </div>
    );
};

export default Stiff_Intro;